export enum ActionTypeEnum {
  HttpRequest = 'http_request',
  ShopifyRemoteMcp = 'shopify_remote_mcp',
  RemoteMcp = 'remote_mcp',
  KnowledgeBase = 'knowledge_base',
  Custom = 'custom',
}

export enum AppActionTypeEnum {
  Campaign = 'campaign',
  Handoff = 'handoff',
}
